export const assignColorOnOrdinalScale = (n) => {
  const colors = [
    '#1f78b4',
    '#b2df8a',
    '#fb9a99',
    '#e31a1c',
    '#fdbf6f',
    '#33a02c',
    '#ff7f00',
    '#cab2d6',
    '#a6cee3',
    '#6a3d9a',
    '#ffff99',
    '#b15928',
  ];
  console.log(n, colors, colors.length, colors[n % colors.length]);
  return colors[n % colors.length];
};
